import { useState, useEffect } from "react";
import "./LuckyGame.css";
import Wheel from "./Wheel";
import RestrictionCard from "./RestrictionCard";
const LuckyGame = () => {
  const [result, setResult] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handleSpinResult = (message) => {
    setResult(message);
    setIsPopupVisible(true); // Show popup after spin
  };

  const closePopup = () => {
    setIsPopupVisible(false);
  };

  //Function to Show the notice popup if the game is over
  const showPopup = () => {
    /* - if date more than 08-March-2025 => notice the game is over.
      - new Date(year, month, day, hours, minutes, seconds, ms) => March 8, 2025, at 23:59:00 in LocalTime. */
    if (new Date() > new Date(2025, 2, 8, 23, 59, 0, 0)) {
      return <RestrictionCard />;
    } else {
      return null;
    }
  };

  return (
    <div id="wrapper">
      {/* if showpopup return value => show value or show Wheel component */}
      {showPopup() ? showPopup() : <Wheel onSpinResult={handleSpinResult} />}

      {isPopupVisible && (
        <div className="popup-overlay">
          <div className="popup-content bg-warning">
            {result.imageUrl === "" ? (
              <div>
                <h2 className="text-primary">Kết quả:</h2>
                <p
                  className="text-danger fw-bold fs-4"
                  style={{ fontFamily: "tahoma" }}
                >
                  {result.prize}
                </p>
              </div>
            ) : (
              <div>
                <img className="w-100" src={result.imageUrl} alt="result" />
              </div>
            )}
            {result.remainRoll > 0 ? (
              <p className="text-primary">{`Bạn còn ${result.remainRoll} lần quay`}</p>
            ) : (
              <p className="text-primary">Bạn đã hết lượt quay</p>
            )}
            <button onClick={closePopup}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};
export default LuckyGame;
